import React from 'react'
import Cta from 'components/flex/Cta/CtaDefault'
import CtaForm from 'components/flex/Cta/CtaForm'

// Components

export interface CtaProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Cta
  location?: any
  projectCategory?: string
}

interface PostProps {
  [key: string]: any
}

const TextShell: React.FC<CtaProps> = ({ fields, location = {} }) => {
  const types: PostProps = {
    default: Cta,
    form: CtaForm,
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default TextShell
